var _defs, _path, _path2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCanvas = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 44.34 44.34"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Canvas_svg__a{fill:#e1402a}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M28.54.93a6.46 6.46 0 0 1-6.37 5.41A6.46 6.46 0 0 1 15.8.93",
  className: "Canvas_svg__a"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M22.17 6.35A6.46 6.46 0 0 0 28.54.93a22.2 22.2 0 0 0-12.74 0 6.46 6.46 0 0 0 6.37 5.42M22.17 38a6.46 6.46 0 0 0-6.37 5.41 22.2 22.2 0 0 0 12.74 0A6.46 6.46 0 0 0 22.17 38M11 11a6.46 6.46 0 0 0 .67-8.33 22.27 22.27 0 0 0-9 9A6.46 6.46 0 0 0 11 11M33.36 33.36a6.46 6.46 0 0 0-.67 8.33 22.26 22.26 0 0 0 9-9 6.46 6.46 0 0 0-8.33.67M6.35 22.17A6.46 6.46 0 0 0 .93 15.8a22.2 22.2 0 0 0 0 12.73 6.46 6.46 0 0 0 5.42-6.36M43.41 15.8a6.45 6.45 0 0 0 0 12.74 22.2 22.2 0 0 0 0-12.74M11 33.36a6.46 6.46 0 0 0-8.33-.67 22.26 22.26 0 0 0 9 9 6.46 6.46 0 0 0-.67-8.33M33.36 11a6.46 6.46 0 0 0 8.33.67 22.27 22.27 0 0 0-9-9 6.46 6.46 0 0 0 .67 8.33",
  className: "Canvas_svg__a"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 22.17,
  cy: 10.27,
  r: 2.04,
  className: "Canvas_svg__a"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 22.17,
  cy: 34.17,
  r: 2.04,
  className: "Canvas_svg__a"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 13.72,
  cy: 13.77,
  r: 2.04,
  className: "Canvas_svg__a",
  transform: "rotate(-45.01 13.722 13.773)"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 30.62,
  cy: 30.67,
  r: 2.04,
  className: "Canvas_svg__a",
  transform: "rotate(-45 30.626 30.674)"
})), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
  cx: 10.22,
  cy: 22.22,
  r: 2.04,
  className: "Canvas_svg__a"
})), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
  cx: 34.12,
  cy: 22.22,
  r: 2.04,
  className: "Canvas_svg__a"
})), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
  cx: 13.72,
  cy: 30.67,
  r: 2.04,
  className: "Canvas_svg__a",
  transform: "rotate(-45 13.726 30.675)"
})), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
  cx: 30.62,
  cy: 13.77,
  r: 2.04,
  className: "Canvas_svg__a",
  transform: "rotate(-44.99 30.621 13.77)"
})));
export { SvgCanvas as ReactComponent };
export default __webpack_public_path__ + "6e9db85a32183d4ce32ba69f8b3b9cb7.svg";